import {
  EntityFormFieldName,
  addLeadCompany,
  addLeadEmailAddress,
  addLeadFirstName,
  addLeadLastName,
  addLeadPhoneNumber,
} from '../constants'

/**
 * Fields that must be collected as a group: at least one member of a group has
 * to stay required, so the form can never be saved with no way to identify or
 * contact the record.
 *
 * Members within a group mutually satisfy each other — marking any one of them
 * required allows the others to be optional:
 *
 * - `firstName` / `lastName` / `company` identify the record.
 * - `emailAddresses` / `phoneNumber` provide a way to reach it.
 *
 * Used to gate the "required" toggle: turning off the last required member of
 * a group is rejected.
 */
export const nameRequiredGroup = 'name'
export const contactRequiredGroup = 'contact'

export type RequiredGroupName =
  | typeof nameRequiredGroup
  | typeof contactRequiredGroup

export const requiredGroups: Record<RequiredGroupName, EntityFormFieldName[]> =
  {
    [nameRequiredGroup]: [addLeadFirstName, addLeadLastName, addLeadCompany],
    [contactRequiredGroup]: [addLeadEmailAddress, addLeadPhoneNumber],
  }

export function findRequiredGroup(
  id: EntityFormFieldName,
): RequiredGroupName | undefined {
  return (Object.keys(requiredGroups) as RequiredGroupName[]).find((group) =>
    requiredGroups[group].includes(id),
  )
}
